import { render, staticRenderFns } from "./Gameboard.vue?vue&type=template&id=1952f12b&scoped=true&"
import script from "./Gameboard.vue?vue&type=script&lang=js&"
export * from "./Gameboard.vue?vue&type=script&lang=js&"
import style0 from "./Gameboard.vue?vue&type=style&index=0&id=1952f12b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1952f12b",
  null
  
)

component.options.__file = "Gameboard.vue"
export default component.exports